module.exports = __webpack_public_path__ + "static/img/审计留痕与可视化报表.cf5028d4.png";